import { DeleteModal } from "@/components/modal/DeleteModal.tsx";
import type { DeleteMetalMutation } from "@/modules/metal/MetalLeaseDetailView.tsx";
import { hasFutureCommitment } from "@/modules/metal/commitment/commitment.ts";
import type { MetalListItemWithPrice } from "@/modules/metal/joinPricesQuery.ts";
import { Trans } from "@lingui/react/macro";
import type { MetalCommitment } from "@warrenio/api-spec/spec.oats.gen";

export interface MetalDeleteModalProps {
    item: MetalListItemWithPrice;
    commitments: MetalCommitment[];
    deleteMutation: DeleteMetalMutation;
}

export function MetalDeleteModal({ item, commitments, deleteMutation }: MetalDeleteModalProps) {
    const { display_name } = item;
    const hasBlockingCommitment =
        item.pricing.pricingType === "commitment" || hasFutureCommitment(commitments, item.uuid);

    async function deleteAction() {
        await deleteMutation.mutateAsync({ uuid: item.uuid, location: item.location });
    }

    return (
        <DeleteModal modalAction={deleteAction} isActionDisabled={hasBlockingCommitment}>
            {hasBlockingCommitment ? (
                <Trans>
                    Deleting "{display_name}" would destroy a resource that has already been paid for. Please contact
                    support for assistance.
                </Trans>
            ) : (
                <Trans>
                    Deleting "{display_name}" will permanently remove it, and it will not be accessible after that.
                </Trans>
            )}
        </DeleteModal>
    );
}
